import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { PracticesService } from '@services/practices.service';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { PracticeCommunicationModel } from '@/models/practice-communication-model';

@Component({
  selector: 'app-button-practice-communication-delete',
  templateUrl: '../button.component.html',
  styleUrls: ['../button.component.scss'],
})
export class ButtonDeletePracticeCommunicationComponent extends ButtonComponent implements OnInit {
  private communication: PracticeCommunicationModel;
  private rowData: any;
  faIcon = faTrashCan;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    private practiceService: PracticesService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  ngOnInit() {
    this.communication = <PracticeCommunicationModel>this.rowData;
  }

  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteCommunication) => {
      if (deleteCommunication) {
        this.practiceService.deleteCommunication(this.communication.id).subscribe({
          next: () => {
            this.toastr.success('Comunicazione cancellata correttamente!');

            Registry.getInstance().get('PracticeDetailsComponent').refreshCommunications();
          },
          error: (error) => {
            LoggerService.error('deleteCommunication failed!');
            LoggerService.error(error);

            this.toastr.error(`Errore durante la cancellazione della comunicazione.`);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questa comunicazione?';
    dialogRef.componentInstance.content =
      'Attenzione una volta cancellata la comunicazione non sarà più possibile recuperarla.';
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
